export default __webpack_public_path__ + "static/media/flamelash.852cb07c.png";